import { render, staticRenderFns } from "./multi-select.vue?vue&type=template&id=cc86aa10&"
import script from "./multi-select.vue?vue&type=script&lang=ts&"
export * from "./multi-select.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports